import logo from "./Images/gw_logo.png";
import logo_green from "./Images/logo_green.png";
import logo_white from "./Images/logo_white.png";
import hero_image from "./Images/hero_image.png";
import Waree_Logo from "./Images/Waaree_Logo.jpg";
import animation from "./Videos/animation.mp4";
import rooftopsolar from "./Images/rooftopsolar.jpg";
import rooftop_solar from "./Images/rooftop_solar.jpg";
import residentialsolar from "./Images/residentialsolar.jpg";
import commercialinst from "./Images/commercialinst.jpg";
import backuppower from "./Images/backuppower.jpg";
import services from "./Images/services.jpg";
import avatar from "./Images/avatar.jpeg";
import contact from "./Images/contact.webp";

export const images = {
  logo_green,
  logo_white,
  logo,
  hero_image,
  Waree_Logo,
  avatar,
  rooftopsolar,
  rooftop_solar,
  residentialsolar,
  commercialinst,
  backuppower,
  services,
  contact,
};
export const videos = {
  animation,
};
